import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const BASE_LABEL = { first: "1st", second: "2nd", third: "3rd" };
const DEFAULT_TIMEOUT_SECS = 20;

export default function HiddenBallModal({ occupiedBases, myRole, fieldingRole, onSelectTarget, timeoutSecs }) {
  const isFielder = myRole === fieldingRole;
  const effectiveTimeout = timeoutSecs > 0 ? timeoutSecs : DEFAULT_TIMEOUT_SECS;
  const [timeLeft, setTimeLeft] = useState(effectiveTimeout);
  const autoFiredRef = useRef(false);

  // Only the fielder makes a choice — timer only runs for them.
  useEffect(() => {
    if (!isFielder || !occupiedBases?.length) return;
    setTimeLeft(effectiveTimeout);
    autoFiredRef.current = false;
    const first = occupiedBases[0];
    const id = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          if (!autoFiredRef.current) {
            autoFiredRef.current = true;
            onSelectTarget(first);
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(id);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFielder]);

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <motion.div
        initial={{ scale: 0.92, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="bg-slate-900 border border-rose-500/40 rounded-2xl p-5 w-full max-w-xs mx-4 shadow-2xl"
      >
        <div className="flex items-center justify-between mb-3">
          <p className="text-xs font-black uppercase tracking-widest text-rose-400">
            Hidden Ball Trick
          </p>
          {isFielder && (
            <span className={`text-xs font-black tabular-nums ${timeLeft <= 5 ? "text-red-400 animate-pulse" : "text-slate-400"}`}>
              {timeLeft}s
            </span>
          )}
        </div>

        {isFielder ? (
          <>
            <p className="text-sm text-slate-300 mb-3 text-center">Choose a runner to call out:</p>
            {(occupiedBases || []).map(base => (
              <button
                key={base}
                onClick={() => onSelectTarget(base)}
                className="w-full mb-2 py-2 px-4 rounded-xl bg-rose-500/20 border border-rose-500/40 text-rose-300 font-bold hover:bg-rose-500/30 transition"
              >
                Runner on {BASE_LABEL[base] || base}
              </button>
            ))}
          </>
        ) : (
          <p className="text-slate-400 text-sm text-center animate-pulse py-2">
            Fielder is picking a runner…
          </p>
        )}
      </motion.div>
    </div>
  );
}
